import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../../data/content";
import { BeforeAfterSlider } from "../BeforeAfterSlider";
import { Reveal, Eyebrow } from "../motion";

export const BeforeAfterSection = () => (
  <section className="bg-[#1D1327] py-24 lg:py-36" data-testid="section-avant-apres">
    <div className="mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-16">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Reveal>
            <Eyebrow>Avant / Après</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-serif text-4xl leading-[1.08] text-cream sm:text-5xl lg:text-6xl">
              Nous ne voyons pas seulement un bien. Nous voyons son potentiel.
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-5 lg:col-start-8 lg:self-end">
          <Reveal delay={0.16}>
            <p className="leading-relaxed text-white/55">
              Faites glisser la séparation pour révéler la transformation : d'un bien à rénover à un hébergement
              différenciant, désirable et rentable.
            </p>
          </Reveal>
        </div>
      </div>

      <Reveal delay={0.1}>
        <div className="mx-auto mt-14 max-w-5xl">
          <BeforeAfterSlider
            before={IMAGES.avantApres.avant}
            after={IMAGES.avantApres.apres}
            altBefore="Appartement vide de Charles à Douai avant travaux — murs blancs et parquet stratifié"
            altAfter="L'Éclipse après transformation — suite privée de luxe avec enseigne lunaire, sauna et néons violets"
          />
          <p className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-2 font-mono text-[10px] uppercase tracking-[0.2em] text-white/35" data-testid="before-after-caption">
            <span>La Black Room de Charles, devenue L'Éclipse — Douai · photos réelles du projet</span>
            <Link to="/etude-de-cas/eclipse" data-testid="before-after-case-study-link" className="inline-flex items-center gap-2 text-neon-light transition-colors hover:text-cream">
              Voir tous les chiffres <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
